export interface TokenSocialRequestDto {
	authProvider: string;
	providerKey: string;
	providerAccessCode: string;
	returnUrl?: string;
	singleSignIn?: boolean;
	avatarUrl?: string;
	name: string;
	surname: string;
	userId: string;
	externalId: string;
}

export interface TokenRequestDto {
	userNameOrEmailAddress?: string;
	password?: string;
	twoFactorVerificationCode?: string;
	rememberClient?: boolean;
	twoFactorRememberClientToken?: string;
	singleSignIn?: boolean;
	returnUrl?: string;
	accessToken?: string;
	refreshToken?: string;
	avatarUrl?: string;
	userName: string;
	userId: string;
	avatar: string;
	name: string;
	surname: string;
	externalId: string;
}

export interface UserCredentials {
	email: string;
	password: string;
}

export enum GrantType {
	Password,
	RefreshToken
}

export enum ExternalLoginProviderType {
	FACEBOOK = 'Facebook',
	GOOGLE = 'Google'
}

export enum UserRole {
	Subscriber = 'Subskrybent',
	Editor = 'Redaktor',
	Admin = 'Administrator',
	Guest = 'Gość'
}
